import React from 'react';
import Navigation from '../navigation';

const PasswordboxContainer: React.FC = () => {
    return (
      <div className='page-layout'>
        <Navigation/>
        <main className='main'>
          <div>Passwordbox</div>
        </main>
      </div>
    );
  };
  
export default PasswordboxContainer;